module.exports = __webpack_public_path__ + "static/media/cut.cd9d7a15.svg";